var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-mark-wrap"},_vm._l((40),function(item,index){return _c('span',{key:index,staticClass:"water-word"},[_vm._v(" "+_vm._s(_vm.userInfo.organizationName)+" "+_vm._s(_vm.userInfo.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }